import Phaser from 'phaser';
import { CST } from '../CST';
import $ from 'jquery';
import { Score } from '../controller/score.js';

var current_question;
var question_index;
var end_index;
var count;
var nextScene;
var questionCorrect = 0;
var quizPoints = 0;
var question;
var story;
var userQuizAnswer;

export default class Main_Questions extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.MAIN_QUESTIONS);
	}

	init() {
		question_index = 0;
		end_index = 1;
		count = 0;
		nextScene = CST.SCENES.STORY_SELECT;
		story = 0;
	}

	preload() {
		// Quiz assets — loaded here so they don't block the initial loading screen
		this.load.image('quiz-box', 'assets/Minigames/mini-quiz/Mini-Quiz - Q Pop-up.png');
		this.load.image('quiz-pop-up', 'assets/Minigames/mini-quiz/quiz-time-popup.png');
		this.load.image('sus-pop-up', 'assets/Minigames/mini-quiz/survey_pop-up.png');
		this.load.image('quiz-intro', 'assets/Minigames/mini-quiz/quiz-instructions-intro.png');
		this.load.image('quiz-outro', 'assets/Minigames/mini-quiz/quiz-outro.png');
		this.load.image('quiz-bg', 'assets/Minigames/mini-quiz/Mini-Quiz Background.png');
		this.load.image('error', 'assets/Minigames/mini-quiz/dropdown-error.png');
		this.load.image('checkbox', 'assets/Buttons/checkbox.png');
		this.load.image('checkbox2', 'assets/Buttons/checkbox-checked.png');
		this.load.image('correct', 'assets/Buttons/Correct.png');
		this.load.image('incorrect', 'assets/Buttons/Incorrect.png');
		this.load.image('confirm', 'assets/Buttons/Confirm.png');
		this.load.audio('correct-sound', 'assets/Sounds/correct-sound.mp3');
		this.load.audio('wrong-sound', 'assets/Sounds/wrong-sound.mp3');
		loadQuestionFromDatabase();
		question = randomiseQuestions(question);
	}

	create(data) {
		this.bg = this.add.image(750, 400, 'quiz-bg').setScale(0.76);
		const click = this.sound.add('click-sound', {
			volume: 0.5,
		});
		const correct = this.sound.add('correct-sound');
		const wrong = this.sound.add('wrong-sound');
		current_question = nextQuestion();
		this.score = new Score(this);
		var style = {
			fontFamily: 'Calibri',
			fontSize: 35,
			color: '#000000',
		};
		var styleFeedback = {
			fontFamily: 'Calibri',
			fontSize: 28,
			color: '#000000',
		};
		var styleAnswer = {
			fontFamily: 'Calibri',
			fontSize: 28,
			color: '#000000',
		};
		this.User_ID = data.User_ID;
		this.quizPopup = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'quiz-box')
			.setScale(0.7);
		var Quest = this.add.text(395, 165, current_question.question, style);
		Quest.setWordWrapWidth(650, true);
		var Feedback = this.add.text(380, 285, current_question.feedback, styleFeedback);
		Feedback.setWordWrapWidth(750, true);
		this.Correct = this.add.sprite(750, 200, 'correct').setScrollFactor(0, 0, 0, 0);
		this.Incorrect = this.add.sprite(750, 200, 'incorrect').setScrollFactor(0, 0, 0, 0);
		this.ConfirmQuiz = this.add.sprite(750, 705, 'confirm').setScrollFactor(0, 0, 0, 0);
		this.ConfirmQuiz.setScale(0.7);
		this.Next_1 = this.add.sprite(750, 705, 'next-btn').setScrollFactor(0, 0, 0, 0).setScale(0.5);
		this.Correct.setScale(0.6);
		this.Incorrect.setScale(0.6);
		Feedback.setVisible(false);
		this.Next_1.setVisible(false);
		this.Correct.setVisible(false);
		this.Incorrect.setVisible(false);

		var Option1 = this.add.sprite(395, 330, 'checkbox').setScrollFactor(0, 0, 0, 0);
		var Option1Text = this.add
			.text(450, 315, current_question.option_1, styleAnswer)
			.setScrollFactor(0, 0, 0, 0);
		Option1Text.setWordWrapWidth(690, true);
		var Option2 = this.add.sprite(395, 400, 'checkbox').setScrollFactor(0, 0, 0, 0);
		var Option2Text = this.add
			.text(450, 385, current_question.option_2, styleAnswer)
			.setScrollFactor(0, 0, 0, 0);
		Option2Text.setWordWrapWidth(690, true);
		var Option3 = this.add.sprite(395, 470, 'checkbox').setScrollFactor(0, 0, 0, 0);
		var Option3Text = this.add
			.text(450, 455, current_question.option_3, styleAnswer)
			.setScrollFactor(0, 0, 0, 0);
		Option3Text.setWordWrapWidth(690, true);
		var Option4 = this.add.sprite(395, 540, 'checkbox').setScrollFactor(0, 0, 0, 0);
		var Option4Text = this.add
			.text(450, 525, current_question.option_4, styleAnswer)
			.setScrollFactor(0, 0, 0, 0);
		Option4Text.setWordWrapWidth(690, true);

		var missing = 0;
		if (current_question.option_3 === null) missing++;
		if (current_question.option_4 === null) missing++;

		var numberOfAnswers = 4 - missing;

		if (numberOfAnswers === 3) {
			Option1.setVisible(true);
			Option2.setVisible(true);
			Option3.setVisible(true);
			Option4.setVisible(false);
			Option1Text.setVisible(true);
			Option2Text.setVisible(true);
			Option3Text.setVisible(true);
			Option4Text.setVisible(false);
		} else if (numberOfAnswers === 2) {
			Option1.setVisible(true);
			Option2.setVisible(true);
			Option3.setVisible(false);
			Option4.setVisible(false);
			Option1Text.setVisible(true);
			Option2Text.setVisible(true);
			Option3Text.setVisible(false);
			Option4Text.setVisible(false);
		} else {
			Option1.setVisible(true);
			Option2.setVisible(true);
			Option3.setVisible(true);
			Option4.setVisible(true);
			Option1Text.setVisible(true);
			Option2Text.setVisible(true);
			Option3Text.setVisible(true);
			Option4Text.setVisible(true);
		}

		var isChecked1 = false;
		var isChecked2 = false;
		var isChecked3 = false;
		var isChecked4 = false;

		Option1.setInteractive({
			useHandCursor: true,
		}).on(
			'pointerdown',
			function () {
				click.play();
				if (isChecked1 == false) {
					isChecked1 = true;
					isChecked2 = false;
					isChecked3 = false;
					isChecked4 = false;
					Option1.setTexture('checkbox2');
					Option2.setTexture('checkbox');
					Option3.setTexture('checkbox');
					Option4.setTexture('checkbox');
				} else if (isChecked1 == true) {
					isChecked1 = false;
					Option1.setTexture('checkbox');
					Option2.setTexture('checkbox');
					Option3.setTexture('checkbox');
					Option4.setTexture('checkbox');
				}
			},
			this,
		);
		Option2.setInteractive({
			useHandCursor: true,
		}).on(
			'pointerdown',
			function () {
				click.play();
				if (isChecked2 == false) {
					isChecked2 = true;
					isChecked1 = false;
					isChecked3 = false;
					isChecked4 = false;
					Option1.setTexture('checkbox');
					Option2.setTexture('checkbox2');
					Option3.setTexture('checkbox');
					Option4.setTexture('checkbox');
				} else if (isChecked2 == true) {
					isChecked2 = false;
					Option1.setTexture('checkbox');
					Option2.setTexture('checkbox');
					Option3.setTexture('checkbox');
					Option4.setTexture('checkbox');
				}
			},
			this,
		);
		Option3.setInteractive({
			useHandCursor: true,
		}).on(
			'pointerdown',
			function () {
				click.play();
				if (isChecked3 == false) {
					isChecked3 = true;
					isChecked2 = false;
					isChecked1 = false;
					isChecked4 = false;
					Option1.setTexture('checkbox');
					Option2.setTexture('checkbox');
					Option3.setTexture('checkbox2');
					Option4.setTexture('checkbox');
				} else if (isChecked3 == true) {
					isChecked3 = false;
					Option1.setTexture('checkbox');
					Option2.setTexture('checkbox');
					Option3.setTexture('checkbox');
					Option4.setTexture('checkbox');
				}
			},
			this,
		);
		Option4.setInteractive({
			useHandCursor: true,
		}).on(
			'pointerdown',
			function () {
				click.play();
				if (isChecked4 == false) {
					isChecked4 = true;
					isChecked3 = false;
					isChecked2 = false;
					isChecked1 = false;
					Option1.setTexture('checkbox');
					Option2.setTexture('checkbox');
					Option3.setTexture('checkbox');
					Option4.setTexture('checkbox2');
				} else if (isChecked4 == true) {
					isChecked4 = false;
					Option1.setTexture('checkbox');
					Option2.setTexture('checkbox');
					Option3.setTexture('checkbox');
					Option4.setTexture('checkbox');
				}
			},
			this,
		);

		this.quizBlackBg = this.add.image(750, 400, 'black-bg');
		this.quizBlackBg.setAlpha(0.55);
		this.quizBlackBg.setScale(8);
		this.quizIntro = this.add.image(750, 400, 'quiz-pop-up');
		this.playButton = this.add.image(750, 700, 'play-btn').setScale(0.7);
		this.playButton.setInteractive().on(
			'pointerdown',
			function () {
				click.play();
				destroySprite(this.quizIntro);
				destroySprite(this.quizBlackBg);
				destroySprite(this.playButton);
			},
			this,
		);

		this.ConfirmQuiz.setInteractive({
			useHandCursor: true,
		}).on(
			'pointerdown',
			function () {
				click.play();
				var answerChecked;
				this.ConfirmQuiz.setVisible(false);
				Quest.setVisible(false);
				Feedback.setVisible(true);
				this.Correct.setVisible(true);
				this.Next_1.setVisible(true);
				this.Next_1.setInteractive();
				Option1.setVisible(false);
				Option2.setVisible(false);
				Option3.setVisible(false);
				Option4.setVisible(false);
				Option1Text.setVisible(false);
				Option2Text.setVisible(false);
				Option3Text.setVisible(false);
				Option4Text.setVisible(false);

				if (isChecked1 == true) {
					answerChecked = Option1Text.text;
				} else if (isChecked2 == true) {
					answerChecked = Option2Text.text;
				} else if (isChecked3 == true) {
					answerChecked = Option3Text.text;
				} else if (isChecked4 == true) {
					answerChecked = Option4Text.text;
				}

				var isCorrect = 0;

				if (answerChecked == current_question.correct_option) {
					correct.play();
					this.Correct.setVisible(true);
					isCorrect = 1;
					this.score.add5Points();
					questionCorrect++;
					quizPoints = quizPoints + 5;
				} else {
					wrong.play();
					this.Incorrect.setVisible(true);
					isCorrect = 0;
				}

				//Getting user Response into a JS Array Object
				userQuizAnswer = {
					User_ID: data.User_ID,
					question_id: current_question.ID,
					question: current_question.question,
					answer: answerChecked,
					correct: isCorrect,
				};

				sendAnswerToDatabase(userQuizAnswer);
			},
			this,
		);

		this.Next_1.setInteractive({
			useHandCursor: true,
		}).on(
			'pointerdown',
			function () {
				click.play();
				this.Next_1.disableInteractive();
				if (end_index === count) {
					this.quizBlackBg = this.add.image(750, 400, 'black-bg');
					this.quizBlackBg.setAlpha(0.55);
					this.quizBlackBg.setScale(8);
					const screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
					const endGameTitle = {
						fontFamily: 'Calibri',
						fontSize: 48,
						color: '#ffffff',
						fontStyle: 'bold',
						padding: 16,
						shadow: {
							color: '#000000',
							fill: true,
							offsetX: 2,
							offsetY: 2,
							blur: 4,
						},
					};
					const endGameFontStyle = {
						fontFamily: 'Calibri',
						fontSize: 38,
						color: '#ffffff',
						padding: 16,
						shadow: {
							color: '#000000',
							fill: true,
							offsetX: 2,
							offsetY: 2,
							blur: 4,
						},
					};
					const clickFontStyle = {
						fontFamily: 'Calibri',
						fontSize: 55,
						color: '#ffffff',
						fontStyle: 'bold',
						padding: 16,
						shadow: {
							color: '#000000',
							fill: true,
							offsetX: 2,
							offsetY: 2,
							blur: 4,
						},
					};
					Feedback.setVisible(false);
					this.endGameText = this.add
						.text(screenCenterX, 200, 'BAGUS SEKALI !', endGameTitle)
						.setOrigin(0.5);
					this.questionCorrectText = this.add
						.text(
							screenCenterX,
							350,
							'Anda telah menjawab ' + questionCorrect + ' pertanyaan dengan benar.',
							endGameFontStyle,
						)
						.setOrigin(0.5);
					this.quizPointsText = this.add
						.text(
							screenCenterX,
							400,
							'Anda menang ' + quizPoints /*this.score.showPoints()*/ + ' poin.',
							endGameFontStyle,
						)
						.setOrigin(0.5);
					this.clickToContinue = this.add
						.text(screenCenterX, 600, 'Klik untuk melanjutkan', clickFontStyle)
						.setOrigin(0.5);
					this.Next_1.setVisible(false);
					setTimeout(() => {
						this.input.once(
							'pointerdown',
							() => {
								click.play();
								this.scene.sendToBack();
								if (story === 0) {
									this.scene.pause();
									this.scene.launch(nextScene, {
										User_ID: this.User_ID,
										story: story,
									});
								} else {
									this.scene.pause();
									this.scene.resume(nextScene, {
										//User_ID: this.User_ID,
										story: story,
									});
								}
							},
							this,
						);
					}, 500);
				} else {
					count++;
					current_question = nextQuestion();
					Quest.text = current_question.question;
					Feedback.text = current_question.feedback;
					Option1Text.text = current_question.option_1;
					Option2Text.text = current_question.option_2;
					Option3Text.text = current_question.option_3;
					Option4Text.text = current_question.option_4;
					Option1.setTexture('checkbox');
					Option2.setTexture('checkbox');
					Option3.setTexture('checkbox');
					Option4.setTexture('checkbox');

					isChecked1 = false;
					isChecked2 = false;
					isChecked3 = false;
					isChecked4 = false;

					missing = 0;
					if (current_question.option_3 === null) missing++;
					if (current_question.option_4 === null) missing++;

					numberOfAnswers = 4 - missing;

					if (numberOfAnswers === 3) {
						Option1.setVisible(true);
						Option2.setVisible(true);
						Option3.setVisible(true);
						Option4.setVisible(false);
						Option1Text.setVisible(true);
						Option2Text.setVisible(true);
						Option3Text.setVisible(true);
						Option4Text.setVisible(false);
					} else if (numberOfAnswers === 2) {
						Option1.setVisible(true);
						Option2.setVisible(true);
						Option3.setVisible(false);
						Option4.setVisible(false);
						Option1Text.setVisible(true);
						Option2Text.setVisible(true);
						Option3Text.setVisible(false);
						Option4Text.setVisible(false);
					} else {
						Option1.setVisible(true);
						Option2.setVisible(true);
						Option3.setVisible(true);
						Option4.setVisible(true);
						Option1Text.setVisible(true);
						Option2Text.setVisible(true);
						Option3Text.setVisible(true);
						Option4Text.setVisible(true);
					}

					this.ConfirmQuiz.setVisible(true);
					this.Correct.setVisible(false);
					this.Incorrect.setVisible(false);
					Quest.setVisible(true);
					Feedback.setVisible(false);
					this.Next_1.setVisible(false);
					this.Correct.setVisible(false);
				}
			},
			this,
		);

		this.events.on('resume', (e, t) => {
			this.scene.bringToTop();
			this.scene.bringToTop(CST.SCENES.UISCENE);
			questionCorrect = 0;
			quizPoints = 0;

			this.quizBlackBg.destroy();
			this.endGameText.destroy();
			this.questionCorrectText.destroy();
			this.quizPointsText.destroy();
			this.clickToContinue.destroy();

			switch (t.story) {
				case 1:
					end_index = 4;
					count = 0;
					//nextScene = CST.SCENES.PAIRS;
					nextScene = CST.SCENES.STORY_SELECT;
					story = t.story;
					//bgMusic = t.bgMusic
					break;
				case 2:
					end_index = 4;
					count = 0;
					//nextScene = CST.SCENES.PAIRS2;
					nextScene = CST.SCENES.STORY_SELECT;
					story = t.story;
					//bgMusic = t.bgMusic
					break;
				case 5:
					end_index = 4;
					count = 0;
					nextScene = CST.SCENES.STORY_SELECT;
					story = t.story;
					//bgMusic = t.bgMusic
					break;
				case 7:
					end_index = 4;
					count = 0;
					//nextScene = CST.SCENES.BRICKS;
					nextScene = CST.SCENES.STORY_SELECT;
					story = t.story;
					//bgMusic = t.bgMusic
					break;
				case 3:
					end_index = 4;
					count = 0;
					nextScene = CST.SCENES.STORY_SELECT;
					story = t.story;
					//bgMusic = t.bgMusic
					break;
				case 4:
					end_index = 4;
					count = 0;
					nextScene = CST.SCENES.STORY_SELECT;
					story = t.story;
					//bgMusic = t.bgMusic
					break;
				case 6:
					end_index = 4;
					count = 0;
					nextScene = CST.SCENES.STORY_SELECT;
					story = t.story;
					//bgMusic = t.bgMusic
					break;
			}
			current_question = nextQuestion();
			Quest.text = current_question.question;
			Feedback.text = current_question.feedback;
			Option1Text.text = current_question.option_1;
			Option2Text.text = current_question.option_2;
			Option3Text.text = current_question.option_3;
			Option4Text.text = current_question.option_4;
			Option1.setTexture('checkbox');
			Option2.setTexture('checkbox');
			Option3.setTexture('checkbox');
			Option4.setTexture('checkbox');

			isChecked1 = false;
			isChecked2 = false;
			isChecked3 = false;
			isChecked4 = false;

			missing = 0;
			if (current_question.option_3 === null) missing++;
			if (current_question.option_4 === null) missing++;

			numberOfAnswers = 4 - missing;

			if (numberOfAnswers === 3) {
				Option1.setVisible(true);
				Option2.setVisible(true);
				Option3.setVisible(true);
				Option4.setVisible(false);
				Option1Text.setVisible(true);
				Option2Text.setVisible(true);
				Option3Text.setVisible(true);
				Option4Text.setVisible(false);
			} else if (numberOfAnswers === 2) {
				Option1.setVisible(true);
				Option2.setVisible(true);
				Option3.setVisible(false);
				Option4.setVisible(false);
				Option1Text.setVisible(true);
				Option2Text.setVisible(true);
				Option3Text.setVisible(false);
				Option4Text.setVisible(false);
			} else {
				Option1.setVisible(true);
				Option2.setVisible(true);
				Option3.setVisible(true);
				Option4.setVisible(true);
				Option1Text.setVisible(true);
				Option2Text.setVisible(true);
				Option3Text.setVisible(true);
				Option4Text.setVisible(true);
			}

			this.ConfirmQuiz.setVisible(true);
			this.Correct.setVisible(false);
			this.Incorrect.setVisible(false);
			Quest.setVisible(true);
			Feedback.setVisible(false);
			this.Next_1.setVisible(false);
			this.Correct.setVisible(false);
		});
	}
}

function loadQuestionFromDatabase() {
	$.ajax({
		async: false,
		type: 'get',
		// url: 'api/get-question-to-json.php', // local
		url: 'website/get-question-to-json.php', // live
		dataType: 'JSON',
		success(data) {
			question = data;
		},
	}).responseJSON;
}

function sendAnswerToDatabase(userQuizAnswer) {
	//Sending JSON string to PHP file
	$.ajax({
		type: 'POST',
		// url: 'api/post-question-to-ddbb.php', // local
		url: 'website/post-question-to-ddbb.php', // live
		dataType: 'JSON',
		data: userQuizAnswer,
	}).responseJSON;
}

function randomiseQuestions(array) {
	for (var i = array.length - 1; i > 0; i--) {
		var j = Math.floor(Math.random() * (i + 1));
		var temp = array[i];
		array[i] = array[j];
		array[j] = temp;
	}
	return array;
}

function nextQuestion() {
	if (question_index != question.length) {
		current_question = question[question_index];
		question_index++;
		return current_question;
	} else {
		question = randomiseQuestions(question);
		question_index = 0;
		nextQuestion();
	}
}

function destroySprite(sprite) {
	sprite.destroy();
}
